import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const PenIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      height={18}
      viewBox="0  0 18 18"
      width={18}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M12.375 2.75366C11.9979 2.75366 11.6246 2.82793 11.2762 2.97223C10.9278 3.11653 10.6113 3.32803 10.3447 3.59465L9.59467 4.34467L2.46967 11.4697C2.32902 11.6103 2.25 11.8011 2.25 12V15C2.25 15.4142 2.58579 15.75 3 15.75H6C6.19891 15.75 6.38968 15.671 6.53033 15.5303L13.6524 8.40824C13.6534 8.40727 13.6544 8.4063 13.6553 8.40533C13.6563 8.40436 13.6573 8.40338 13.6582 8.40241L14.4053 7.65531C14.672 7.38869 14.8835 7.07215 15.0278 6.72379C15.1721 6.37542 15.2463 6.00205 15.2463 5.62498C15.2463 5.24792 15.1721 4.87454 15.0278 4.52618C14.8835 4.17781 14.672 3.86128 14.4053 3.59465C14.1387 3.32803 13.8222 3.11653 13.4738 2.97223C13.1254 2.82793 12.7521 2.75366 12.375 2.75366ZM13.125 6.81433L13.3447 6.59465C13.472 6.46731 13.573 6.31614 13.6419 6.14976C13.7109 5.98339 13.7463 5.80507 13.7463 5.62498C13.7463 5.4449 13.7109 5.26658 13.6419 5.1002C13.573 4.93383 13.472 4.78265 13.3447 4.65531C13.2173 4.52797 13.0662 4.42696 12.8998 4.35805C12.7334 4.28913 12.5551 4.25366 12.375 4.25366C12.1949 4.25366 12.0166 4.28913 11.8502 4.35805C11.6838 4.42696 11.5327 4.52797 11.4053 4.65531L11.1857 4.87499L13.125 6.81433ZM10.125 5.93565L3.75 12.3106V14.25H5.68934L12.0643 7.87499L10.125 5.93565Z"
        fill="#2C3E50"
        fillRule="evenodd"
      />
    </svg>
  );
};
